import request from '@/utils/request'

/**
 * 许可证列表
 */
export const getActivationPage = (params: any) => {
  return request({
    url: '/blackcat/activation/page',
    method: 'get',
    params
  })
}
/**
 * 许可证权限
 */
export const getActivationResource = (params: any) => {
  return request({
    url: '/blackcat/activation/resource',
    method: 'get',
    params
  })
}
